module.exports = __webpack_public_path__ + "img/jpyc8.b36b2170.png";